import type {PaymentPlan, ProgramPaymentType} from './types';

import {getUuid} from '../../../getUuid';
import {Currency} from '../../../money';
import {MIN_DURATION_FOR_MONTHLY_PAYMENT, parseDuration} from '../duration';
import {DefaultPaymentPlan, MIN_PRICE} from './constants';
import {getAverageMonthlyPayment} from './getAverageMonthlyPayment';
import {ProgramPaymentTypeEnum} from './programPaymentTypeEnum';

export const createPaymentPlan = ({
  currency = Currency.USD,
  duration = 0,
  paymentType = ProgramPaymentTypeEnum.ONE_TIME,
  price = MIN_PRICE,
  processing = 'internal',
}: {
  currency?: Currency;
  duration: number;
  paymentType?: ProgramPaymentType;
  price: number;
  processing?: PaymentPlan['processing'];
}): PaymentPlan => {
  const paymentPlan: PaymentPlan = {
    ...DefaultPaymentPlan,
    // @ts-expect-error: TODO: describy why
    currency: currency.id.toUpperCase(),
    processing,
    schedule: [],
  };

  if (price > 0) {
    const parsedDuration = parseDuration(duration);
    const monthlyPayment = getAverageMonthlyPayment(price, parsedDuration.num);

    paymentPlan.total = price;

    if (
      paymentType.id === ProgramPaymentTypeEnum.MONTHLY.id &&
      duration >= MIN_DURATION_FOR_MONTHLY_PAYMENT
    ) {
      let counter = 0;

      while (counter !== parsedDuration.num) {
        let day = counter * parsedDuration.unit.multiplier - 1;

        if (day < 0) {
          day = 0;
        }

        let amount = monthlyPayment;

        if (counter === parsedDuration.num - 1) {
          amount = price - monthlyPayment * (parsedDuration.num - 1);
        }

        const uuid = getUuid();

        paymentPlan.schedule.push({amount, day, uuid});

        counter += 1;
      }
    } else {
      const uuid = getUuid();

      paymentPlan.schedule.push({amount: price, day: 0, uuid});
    }
  }

  return paymentPlan;
};
